import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';
import { env } from 'process';

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  constructor(
    private _http: HttpClient
  ) { }

  public deactivateSub(subId:number, userId:number):Observable<any>
  {
    return this._http.put(environment.apiEndpoint+`/api/admin/deactivateMemberSub`,{
      userId:userId,
      subId:subId
    }).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public downloadMembersCSV():Observable<any>
  {
    return this._http.get(environment.apiEndpoint+'/api/admin/membersCSV',{ responseType: 'text' });
  }

  public downloadPurchaseData():Observable<any>
  {
    return this._http.get(environment.apiEndpoint+'/api/admin/memberPurchaseDataCSV', {responseType: 'text'});
  }

  public recalcUserPoints():Observable<any>
  {
    return this._http.get(environment.apiEndpoint+'/api/admin/regenerateUserPoints').pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public generateResetLink(memberId):Observable<any>
  {
    return this._http.post(environment.apiEndpoint+'/api/admin/member/generateResetToken', {memberId:memberId}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getPaginatedMembers(page, pp, filters): Observable<iHttpPaginatedResponse>{
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint+`/api/admin/members?page=${page}&pp=${pp}&${filters}`).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getPaginatedAdmins(page, pp, filters): Observable<iHttpPaginatedResponse>{
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint+`/api/admin/admins?page=${page}&pp=${pp}&${filters}`).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getMember(id:number):Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/admin/member/'+id).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public setMemberMentor(memberId:number, mentorId:number):Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/updateMemberMentor',{memberId:memberId, mentorId:mentorId}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public createAdministrator(administrator:any):Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/admin/administrator/create', {first_name:administrator.first_name, last_name:administrator.last_name, email:administrator.email, password:administrator.password}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public updateAdministratorStatus(id:number, status:number): Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/admin/administrator/'+id, {deleted:status}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public resendUserVerificationEmail(userId:number):Observable<any>{
    return this._http.put(environment.apiEndpoint+`/api/admin/resend-verification`, {memberId:userId}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public searchUsers(q: string): Observable<any> {
    return this._http.get(environment.apiEndpoint + `/api/admin/users/search?q=${encodeURIComponent(q)}`).pipe(
      map(res => { return res; })
    );
  }

  public getPlans(): Observable<any> {
    return this._http.get(environment.apiEndpoint + '/api/subscription/plans').pipe(
      map(res => { return res; })
    );
  }

  public createManualSubscription(userId: number, planId: number, subUntil: string): Observable<any> {
    return this._http.post(environment.apiEndpoint + '/api/admin/subscription', {
      user_id: userId,
      plan_id: planId,
      sub_until: subUntil
    }).pipe(
      map(res => { return res; })
    );
  }

  public getSubscription(id: number): Observable<any> {
    return this._http.get(environment.apiEndpoint + `/api/admin/subscription/${id}`).pipe(
      map(res => { return res; })
    );
  }

  public updateSubscription(id: number, subUntil: string): Observable<any> {
    return this._http.put(environment.apiEndpoint + `/api/admin/subscription/${id}`, { sub_until: subUntil }).pipe(
      map(res => { return res; })
    );
  }

  public getSubscriptions(page: number, pp: number, filters: any = {}): Observable<any> {
    let params = `page=${page}&pp=${pp}`;
    if (filters.q) params += `&q=${encodeURIComponent(filters.q)}`;
    if (filters.plan) params += `&plan=${encodeURIComponent(filters.plan)}`;
    if (filters.status) params += `&status=${encodeURIComponent(filters.status)}`;
    return this._http.get(environment.apiEndpoint + `/api/admin/subscriptions?${params}`).pipe(
      map(res => { return res; })
    );
  }
}
